module.exports = __webpack_public_path__ + "static/media/kuro-organisation-ill.df634498.svg";